import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuButtonOption} from '@Components/contextual-menu/components/contextual-menu-button-option';
import type {ButtonItemsStorageType} from '@Components/contextual-menu/components/button-items';
import { ContextualButtonItemType} from '@Components/contextual-menu/components/button-items';
import {Size, Type} from '@Components/button';

interface BaseEditContentOptionProps {
  onClick(): void;
}

export function BaseEditContentOption({...props}: BaseEditContentOptionProps): ReactElement<any> {
  const onClickHandler = (): void => {
    props.onClick();
  };

  const getData = (): ButtonItemsStorageType => {
    return [
      {
        id: 'edit-content-button',
        type: ContextualButtonItemType.CUSTOM_BUTTON,
        text: window.i18next.t('pmwjs_edit_content'),
        buttonType: Type.GHOST,
        buttonSize: Size.SMALL,
        icon: 'icon-pencil',
        onClick: onClickHandler,
      },
    ];
  };

  return <ContextualMenuButtonOption isInlineOption label={window.i18next.t('pmwjs_edit_item')} id="item-edit-content-option" data={getData()} />;
}
